import styled, { keyframes } from 'styled-components'

const SHADOW_CARD = '0px 0px 4px 0px rgba(43,123,199,0.25)'
const CARD_CLIP   = 'polygon(0% 8%, 8% 0%, 100% 0%, 100% 92%, 92% 100%, 0% 100%)'

/* ── Page ───────────────────────────────────────────────────── */

export const PageWrapper = styled.div`
  background: white;
  min-height: 100vh;
`

/* ── Header ─────────────────────────────────────────────────── */

export const PageHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 1.25rem;
  padding: 2rem 2.5rem 1.25rem;
`

export const PageIconBox = styled.div`
  width: 4.0625rem;
  height: 4.0625rem;
  border-radius: 0.9375rem;
  background: linear-gradient(223deg, rgba(0,200,248,1) 16%, rgba(104,94,252,1) 78%);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`

export const PageIconImg = styled.img`
  width: 2.0625rem;
  height: 2.0625rem;
  object-fit: contain;
`

export const PageTitle = styled.h1`
  font-family: Poppins;
  font-size: 2rem;
  font-weight: 600;
  color: #000000;
  margin: 0;
  line-height: 1.15;
`

export const PageSubtitle = styled.p`
  font-family: Poppins;
  font-size: 1rem;
  font-weight: 400;
  color: #000000;
  opacity: 0.55;
  margin: 0;
`

/* ── Stepper ─────────────────────────────────────────────────── */

export const StepsBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: 0 2.5rem 1.5rem;
`

export const StepItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-family: Poppins;
  font-size: 0.875rem;
  font-weight: 600;
  color: ${props => props.active ? '#000000' : '#BABABA'};
`

export const StepNumber = styled.div`
  width: 1.4375rem;
  height: 1.4375rem;
  border-radius: 50%;
  background: ${props => props.completed ? '#E1F5DD' : props.active ? '#00A3FF' : '#DADADA'};
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Poppins;
  font-size: 0.8rem;
  font-weight: 700;
  color: ${props => props.completed ? '#34B81A' : 'white'};
  flex-shrink: 0;
`

export const StepDivider = styled.div`
  width: 4.25rem;
  height: 1px;
  background: #E2E2E2;
`

/* ── Cart grid ───────────────────────────────────────────────── */

export const CartGrid = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 1.5rem;
  padding: 0 2.5rem 3rem;
`

export const ItemsList = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`

export const ItemCard = styled.div`
  background: white;
  border-radius: 0.75rem;
  box-shadow: ${SHADOW_CARD};
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.8125rem 1rem;
  min-height: 5.125rem;
`

export const ItemThumb = styled.div`
  width: 3.625rem;
  height: 3.625rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
  & img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`

export const ItemInfo = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
`

export const ItemCategory = styled.span`
  font-family: Poppins;
  font-size: 0.625rem;
  font-weight: 700;
  color: ${props => props.color || '#6462FC'};
  text-transform: uppercase;
  letter-spacing: 0.1em;
`

export const ItemTitle = styled.span`
  font-family: Poppins;
  font-size: 0.875rem;
  font-weight: 400;
  color: #000000;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const QuantityControls = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid #F1F1F1;
  border-radius: 0.4375rem;
  overflow: hidden;
  flex-shrink: 0;
`

export const QtyButton = styled.button`
  width: 1.8125rem;
  height: 1.875rem;
  background: #F2F2F2;
  border: none;
  font-family: Poppins;
  font-size: 1rem;
  font-weight: 600;
  color: #000000;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s;
  &:hover { background: #64E1FF; color: white; }
`

export const QtyValue = styled.span`
  min-width: 2rem;
  text-align: center;
  font-family: Poppins;
  font-size: 0.875rem;
  font-weight: 600;
  color: #000000;
  border-left: 1px solid #F1F1F1;
  border-right: 1px solid #F1F1F1;
  padding: 0 0.25rem;
  height: 1.875rem;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const ItemPrice = styled.span`
  font-family: Poppins;
  font-size: 0.875rem;
  font-weight: 600;
  color: #000000;
  white-space: nowrap;
  flex-shrink: 0;
  min-width: 3.5rem;
  text-align: right;
`

export const RemoveButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.3rem;
  border-radius: 0.375rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  & img {
    width: 1.25rem;
    height: 1.25rem;
    object-fit: contain;
    filter: brightness(0) opacity(0.35);
    transition: filter 0.15s;
  }
  &:hover img {
    filter: brightness(0) saturate(100%) invert(18%) sepia(99%) saturate(7400%) hue-rotate(2deg) brightness(98%) contrast(110%);
  }
`

/* ── Summary card ────────────────────────────────────────────── */

export const SummaryCardWrapper = styled.div`
  flex-shrink: 0;
  width: 28.125rem;
  filter: drop-shadow(0px 0px 5.52px rgba(43,123,199,0.25));
`

export const SummaryCard = styled.div`
  background: white;
  clip-path: ${CARD_CLIP};
  padding: 1.75rem 2rem 1.75rem 1.75rem;
  display: flex;
  flex-direction: column;
`

export const SummaryTitle = styled.h2`
  font-family: Poppins;
  font-size: 1.5rem;
  font-weight: 700;
  color: #00A3FF;
  margin: 0 0 0.75rem;
`

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: #E2E2E2;
  margin: 0.5rem 0;
`

export const SummaryRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.25rem 0;
`

export const SummaryLabel = styled.span`
  font-family: Poppins;
  font-size: 0.875rem;
  font-weight: 400;
  color: #000000;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 60%;
`

export const SummaryValue = styled.span`
  font-family: Poppins;
  font-size: 0.875rem;
  font-weight: 600;
  color: #000000;
  white-space: nowrap;
`

export const SubtotalRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.2rem 0;
`

export const SubtotalLabel = styled.span`
  font-family: Poppins;
  font-size: 0.875rem;
  font-weight: 400;
  color: #BABABA;
`

export const SubtotalValue = styled.span`
  font-family: Poppins;
  font-size: 0.875rem;
  font-weight: 600;
  color: #BABABA;
`

export const TotalRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.4rem 0 0.75rem;
`

export const TotalLabel = styled.span`
  font-family: Poppins;
  font-size: 1.5rem;
  font-weight: 400;
  color: #000000;
`

export const TotalValue = styled.span`
  font-family: Poppins;
  font-size: 1.5rem;
  font-weight: 600;
  color: #000000;
`

export const CheckoutButton = styled.button`
  width: 100%;
  height: 2.6875rem;
  background: #8EA2FF;
  border: 1px solid #4465FE;
  border-radius: 0.4375rem;
  font-family: Poppins;
  font-size: 1.125rem;
  font-weight: 600;
  color: white;
  cursor: pointer;
  margin-top: 0.5rem;
  transition: background 0.15s;
  &:hover { background: #7B91FF; }
`

export const TrustText = styled.p`
  font-family: Poppins;
  font-size: 0.8125rem;
  font-weight: 400;
  color: #BABABA;
  line-height: 1.75;
  margin: 0.75rem 0 0;
  white-space: pre-line;
`

/* ── Empty / loading states ──────────────────────────────────── */

export const StateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 5rem 2.5rem;
  gap: 1rem;
`

export const EmptyIllustration = styled.div`
  font-size: 3.5rem;
  line-height: 1;
  margin-bottom: 0.5rem;
`

export const StateTitle = styled.p`
  font-family: Poppins;
  font-size: 1.5rem;
  font-weight: 400;
  color: #000000;
  margin: 0;
`

export const StateSubtitle = styled.p`
  font-family: Poppins;
  font-size: 0.9375rem;
  font-weight: 400;
  color: #BABABA;
  margin: 0;
  max-width: 28rem;
`

export const PrimaryButton = styled.button`
  height: 2.6875rem;
  padding: 0 1.5rem;
  background: #8EA2FF;
  border: 1px solid #4465FE;
  border-radius: 0.4375rem;
  font-family: Poppins;
  font-size: 0.9375rem;
  font-weight: 600;
  color: white;
  cursor: pointer;
  transition: background 0.15s;
  &:hover { background: #7B91FF; }
`

/* ── Payment step (Stripe Checkout redirect) ─────────────────── */

export const PaymentSection = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
`

export const PaymentTitle = styled.h2`
  font-family: Poppins;
  font-size: 1.5rem;
  font-weight: 600;
  color: #000000;
  margin: 0 0 1.25rem;
`

export const StripeSecureBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  background: #F6F9FF;
  border-radius: 0.5rem;
  border: 1px solid #E8EDFF;
  margin-bottom: 1.25rem;
  font-family: Poppins;
  font-size: 0.875rem;
  font-weight: 500;
  color: #4465FE;
`

export const PayConfirmInfo = styled.p`
  font-family: Poppins;
  font-size: 0.9375rem;
  font-weight: 400;
  color: #6B7280;
  line-height: 1.65;
  margin: 0 0 1.5rem;
`

export const StripeError = styled.p`
  font-family: Poppins;
  font-size: 0.75rem;
  color: #FF4D4D;
  margin: -0.5rem 0 0.75rem;
`

export const PayNowBtn = styled.button`
  width: 100%;
  height: 2.6875rem;
  background: ${props => props.disabled ? '#CACACA' : '#8EA2FF'};
  border: 1px solid ${props => props.disabled ? '#9E9E9E' : '#4465FE'};
  border-radius: 0.4375rem;
  font-family: Poppins;
  font-size: 1.25rem;
  font-weight: 600;
  color: white;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  margin-bottom: 0.75rem;
  transition: background 0.15s;
  &:hover { background: ${props => props.disabled ? '#CACACA' : '#4465FE'}; }
`

export const LegalText = styled.p`
  font-family: Poppins;
  font-size: 0.625rem;
  font-weight: 600;
  color: #000000;
  line-height: 1.55;
  margin: 0;
`

/* ── Retractation modal ──────────────────────────────────────── */

export const RetractOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(33, 76, 107, 0.5);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const RetractModal = styled.div`
  background: #FFFFFF;
  border-radius: 0.625rem;
  box-shadow: 0px 0px 4px 0px rgba(43,123,199,0.25);
  width: 36.8125rem;
  padding: 2.25rem 2rem 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const RetractTitle = styled.h2`
  font-family: Poppins;
  font-size: 1.25rem;
  font-weight: 600;
  color: #000000;
  margin: 0;
`

export const RetractBody = styled.p`
  font-family: Poppins;
  font-size: 0.875rem;
  font-weight: 600;
  color: #000000;
  line-height: 1.65;
  margin: 0;
`

export const RetractBtnRow = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 0.25rem;
`

export const RetractCancelBtn = styled.button`
  flex: 1;
  height: 2.6875rem;
  background: #CACACA;
  border: 1px solid #9E9E9E;
  border-radius: 0.4375rem;
  font-family: Poppins;
  font-size: 0.875rem;
  font-weight: 600;
  color: white;
  cursor: pointer;
  transition: background 0.15s;
  &:hover { background: #B5B5B5; }
`

export const RetractAcceptBtn = styled.button`
  flex: 1;
  height: 2.6875rem;
  background: #8EA2FF;
  border: 1px solid #4465FE;
  border-radius: 0.4375rem;
  font-family: Poppins;
  font-size: 0.875rem;
  font-weight: 600;
  color: white;
  cursor: pointer;
  transition: background 0.15s;
  &:hover { background: #4465FE; }
`

/* ── Success / cancel pages (PanierSucces, PanierAnnule) ─────── */

export const StatusPage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 5rem 2.5rem;
  gap: 1rem;
`

export const GradientTitle = styled.h1`
  font-family: Poppins;
  font-size: 2rem;
  font-weight: 600;
  background: linear-gradient(90deg, #685EFC 0%, #01C8F8 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin: 0;
`

export const StatusSubtitle = styled.p`
  font-family: Poppins;
  font-size: 1.25rem;
  font-weight: 400;
  color: #000000;
  margin: 0;
`

export const StatusBody = styled.p`
  font-family: Poppins;
  font-size: 0.875rem;
  font-weight: 400;
  color: #000000;
  max-width: 42rem;
  line-height: 1.65;
  margin: 0;
`

export const StatusBtn = styled.button`
  width: 15.625rem;
  height: 2.6875rem;
  background: #8EA2FF;
  border: 1px solid #4465FE;
  border-radius: 0.4375rem;
  font-family: Poppins;
  font-size: 0.875rem;
  font-weight: 600;
  color: white;
  cursor: pointer;
  transition: background 0.15s;
  &:hover { background: #4465FE; }
  margin-top: 0.25rem;
`

/* ── Spinner (polling state in PanierSucces) ─────────────────── */

const spin = keyframes`to { transform: rotate(360deg); }`

export const Spinner = styled.div`
  width: 3rem;
  height: 3rem;
  border: 4px solid #E2E2E2;
  border-top-color: #00A3FF;
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
  flex-shrink: 0;
`
